import { Pipe, PipeTransform } from '@angular/core';
import { SimXInstitution } from '../models/entities/simx-institution.model';

@Pipe({ name: 'institutionExpirationWindow' })
export class InstitutionExpirationWindowPipe implements PipeTransform {
  transform(institution: SimXInstitution): number {
    const { expiration } = institution;
    if (!expiration) {
      return Infinity;
    } else {
      const institutionExpirationDate = new Date(expiration);
      const windowInDays = Math.round(
        (institutionExpirationDate.getTime() - new Date().getTime()) /
          (1000 * 60 * 60 * 24),
      );
      return windowInDays;
    }
  }
}
